var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3405_7248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0.5C5.38314 0.5 0 5.88323 0 12.5001C0 19.117 5.38314 24.5 12.0001 24.5C18.6169 24.5 24 19.117 24 12.5001C24 5.88323 18.6169 0.5 12.0001 0.5Z",
    fill: "#ADCEEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1595 19.9633C9.51259 18.0477 6.6872 15.4774 3.36035 15.4774V18.3867C6.3275 18.3867 9.32763 22.1106 10.2332 23.5454L11.709 25.8838L12.801 23.3442C12.8703 23.183 19.8236 7.1611 28.6862 1.70425L27.1608 -0.772934C19.5176 3.93321 13.4866 15.1532 11.1595 19.9633Z",
    fill: "#E1ECF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3405_7248"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckmark);
export default __webpack_public_path__ + "static/media/blue-checkmark.2218e7ba0b947457685aed7a02d20230.svg";
export { ForwardRef as ReactComponent };